module.exports = __webpack_public_path__ + "img/performance-status-widget-illustration-1.65ba6a1d.png";